export default __webpack_public_path__ + "static/media_background-d09a206e44ef2cf8ab02cd222292b328.png";